<section class="popups">
    <div class="popup-header">
        <div class="header-content">
            <h4>{{data.heading | translate}}</h4>
            <img (click)="onNoClick()" alt="" src="assets/images/cross-icon.svg">
        </div>
    </div>
    <form (ngSubmit)="onSubmit()" [formGroup]="addCustomerForm">
        <div class="popup-body">
            <div class="popup-content m-auto text-center">
                <mat-form-field *ngIf="data.type === 'reject'" appearance="outline" class="element-full-width">
                    <mat-label>{{data.message | translate}} <span style="color:#EA5455">*</span></mat-label>
                    <textarea formControlName="reason" matInput placeholder="{{'GENERAL.TypeHere' | translate}}"
                        type="text"></textarea>
                    <mat-error *ngIf="addCustomerForm.controls.reason.errors?.required">
                        {{data.message | translate}}.
                    </mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" class="element-full-width">
                    <mat-label>{{data.message1 | translate}} <span style="color:#EA5455">*</span></mat-label>
                    <textarea formControlName="internalComment" matInput
                        placeholder="{{'GENERAL.TypeHere' | translate}}" type="text"></textarea>
                    <mat-error *ngIf="addCustomerForm.controls.internalComment.errors?.required">
                        {{data.message1 | translate}}.
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <hr>
        <div class="popup-footer">
            <div class="footer-content">
                <button *ngIf="data.type === 'reject'" class="btn-style theme-btn" type="submit">
                    {{'Procurement_Management.Reject' | translate}}</button>
                <button *ngIf="data.type === 'accept'" class="btn-style theme-btn"
                    type="submit">{{'ORDERMANAGEMENT.MANAGECUSTOMER.Approve' | translate}}</button>
                <button (click)="onNoClick()" class="btn-style inactive" type="button">{{'Cancel' | translate}}</button>
            </div>
        </div>
    </form>
</section>